<template lang='pug'>
  DataMaster(:title='title')
</template>

<script>
import axios from "axios";
import DataMaster from "../components/DataMasterList.vue";
export default {
  name: "Data BU",
  components: {
    DataMaster
  },
  data: () => ({
    title: "Business Unit"
  }),
  mounted() {
   
  },

  methods: {
 
  }
};
</script>
